// src/components/ui/progress.tsx
"use client"

import React from "react"
import type { ElementRef, ComponentPropsWithoutRef } from "react"
import {
  Root as ProgressRoot,
  Indicator as ProgressIndicator,
} from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef<
  ElementRef<typeof ProgressRoot>,
  ComponentPropsWithoutRef<typeof ProgressRoot> & { value?: number }
>(({ className, value = 0, ...props }, ref) => (
  <ProgressRoot
    ref={ref}
    className={cn("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className)}
    {...props}
  >
    <ProgressIndicator
      className="h-full w-full flex-1 bg-primary transition-transform will-change-transform"
      style={{ transform: `translateX(-${100 - value}%)` }}
    />
  </ProgressRoot>
))
Progress.displayName = "Progress"

export { Progress }